import useSWR from 'swr'

export interface TokenPrices {
  zeal?: { usd: number }
  nacho?: { usd: number }
  krex?: { usd: number }
  keiro?: { usd: number }
  kaspy?: { usd: number }
  wolfy?: { usd: number }
  kroak?: { usd: number }
  kasbtc?: { usd: number }
  crumbs?: { usd: number }
  bite?: { usd: number }
  kyro?: { usd: number }
  ppkas?: { usd: number }
  kango?: { usd: number }
  kasper?: { usd: number }
  konan?: { usd: number }
  ghoad?: { usd: number }
  slow?: { usd: number }
  dogk?: { usd: number }
  keke?: { usd: number }
  burt?: { usd: number }
  kappy?: { usd: number }
  bomo?: { usd: number }
  pacman?: { usd: number }
  stick?: { usd: number }
  koba?: { usd: number }
  szar?: { usd: number }
  bara?: { usd: number }
  wiener?: { usd: number }
  froppy?: { usd: number }
  burtle?: { usd: number }
  popkat?: { usd: number }
  bkonan?: { usd: number }
  wadu?: { usd: number }
  kirby?: { usd: number }
  jrry?: { usd: number }
  kaslot?: { usd: number }
  krep?: { usd: number }
  knight?: { usd: number }
  geek?: { usd: number }
  koak?: { usd: number }
  kaspa?: { usd: number }
  [key: string]: { usd: number } | undefined // Allow for additional tokens
}

export interface PriceAPIResponse {
  prices: TokenPrices
  timestamp: string
  count: number
}

const fetcher = async (url: string): Promise<TokenPrices> => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error('Failed to fetch prices')
  }
  const data: PriceAPIResponse = await response.json()
  return data.prices
}

/**
 * Hook to fetch current USDT prices for KAS, NACHO, and ZEAL tokens
 * from kaspafinance.io price API
 *
 * @returns SWR response with token prices in USDT
 */
export const usePriceAPI = () => {
  return useSWR<TokenPrices>('https://api.kaspafinance.io/price', fetcher, {
    refreshInterval: 30_000, // Refresh every 30 seconds
    revalidateOnFocus: false,
    dedupingInterval: 10_000, // Dedupe requests within 10 seconds
  })
}
